import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getEmployeeOrderList } from './ThunkAction';
import { iOrderState, REDUCER_NAME } from './Types';

const initialState: iOrderState = {
  isLoading: false,
  orders: null, // keep if you use it elsewhere
  errorMessage: null,
  EmployeesOrderList: [],
  forwardItems: null,
};

export const employeeOrderSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetOrderState: () => initialState,
    clearForwardOrderItems: (state) => {
      state.forwardItems = null;
    },

    // optional: if you ever want to manually clear list
    clearEmployeesOrderList: (state) => {
      state.EmployeesOrderList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeeOrderList.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getEmployeeOrderList.fulfilled, (state, action) => {
        state.isLoading = false;

        const payload = action.payload;
        const orders = payload?.data?.orders;

       
        // @ts-expect-error
        state.EmployeesOrderList = Array.isArray(orders) ? orders : [];
      })
      .addCase(getEmployeeOrderList.rejected, (state, action) => {
        state.isLoading = false;

      
        
        // @ts-expect-error
        state.errorMessage =action.payload?.message ?? action.error?.message ?? 'Failed to fetch order list';
      });
  },
});

export const { resetOrderState, clearForwardOrderItems, clearEmployeesOrderList } =
  employeeOrderSlice.actions;

export default employeeOrderSlice.reducer;
